module.exports = __webpack_public_path__ + "img/u367.dc27d601.png";